// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"89f77a91","133":"5376e5da","271":"700ae427","325":"e8ee3f28","343":"26995078","365":"5376e5da","556":"89f77a91","652":"5376e5da","767":"e8ee3f28"}[chunkId] + ".chunk.css";
};